export const css = {
	root: '_1KyH0AvW',
	welcome: 'FOIvwrwM',
	header: '_3bJMHcPw',
	confirm: '_1hk5SQAk',
	questionWrapper: '_18hTbgkx',
	submit: '_3WZ3rnQ4',
	required: '_16y54jaR',
	progress: '_1DmKBqki',
	dot: 'f8zxAnot',
	activeDot: '_122eRNmH',
	buttons: '_3dlZmOPn',
	pathSelect: 'KWQyEoek',
	startButton: '_3-YiF7fC',
	' _key': 'landing-page/survey'
};

export default css;
